import styled from 'styled-components'
import Modal from 'components/Modal'

export default styled(Modal)`
  width: 100%;
  max-width: 868px;

  h3 {
    font: var(--600-24);
    margin-bottom: 16px;
  }

  h4 {
    font: var(--600-16);
    text-align: start;
  }
`
